import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { COMMERCE } from '@shared/api/endpoints';
import type { AnalysisProgress, JobInitiateResponse } from '@tailorcast/shared-types';

export function useAnalysisProgress() {
  return useQuery({
    queryKey: ['analysis', 'status'],
    queryFn: () => api.get<AnalysisProgress>(COMMERCE.ANALYZE_STATUS),
    refetchInterval: (query) =>
      query.state.data?.status === 'running' || query.state.data?.status === 'pending'
        ? 2000
        : false,
  });
}

export function useTriggerAnalysis() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.post<JobInitiateResponse>(COMMERCE.ANALYZE_START, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['analysis', 'status'] });
    },
  });
}
